var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLogoutOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / Log-out",
    clipPath: "url(#clip0_7604_878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70004 1.47777C7.70004 1.09117 7.38663 0.777771 7.00004 0.777771C6.61344 0.777771 6.30004 1.09117 6.30004 1.47777V8.08888C6.30004 8.47548 6.61344 8.78888 7.00004 8.78888C7.38663 8.78888 7.70004 8.47548 7.70004 8.08888V1.47777Z",
    fill: "var(--red-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3027 2.69543C3.61417 2.46532 4.04591 2.58326 4.23954 2.91863C4.43316 3.254 4.31422 3.67913 4.01047 3.91933C3.3831 4.41543 2.886 5.06237 2.56858 5.80447C2.15876 6.76257 2.07049 7.82767 2.317 8.84016C2.5635 9.85265 3.1315 10.758 3.93587 11.4205C4.74024 12.0829 5.73765 12.4669 6.77861 12.5148C7.81957 12.5626 8.84802 12.2719 9.7098 11.686C10.5716 11.1002 11.2203 10.2508 11.5587 9.26521C11.8971 8.27963 11.907 7.21091 11.5868 6.21925C11.3389 5.45114 10.9032 4.7613 10.3241 4.20971C10.0436 3.94264 9.96422 3.50839 10.1878 3.19221C10.4114 2.87603 10.8522 2.79822 11.1412 3.05594C11.9638 3.78949 12.5802 4.73156 12.9214 5.78842C13.3347 7.06861 13.3219 8.44827 12.885 9.72062C12.4482 10.993 11.6107 12.0895 10.4982 12.8458C9.38569 13.6021 8.05802 13.9775 6.71418 13.9156C5.37035 13.8538 4.08274 13.3582 3.04433 12.5029C2.00593 11.6477 1.27266 10.479 0.954434 9.1719C0.636207 7.86482 0.750159 6.48982 1.27921 5.25296C1.71597 4.23189 2.4162 3.35037 3.3027 2.69543Z",
    fill: "var(--red-5)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7604_878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOutlined);
export default __webpack_public_path__ + "static/media/logoutOutlined.e27fe869f95028c41d3625e4c8a53e48.svg";
export { ForwardRef as ReactComponent };